import CardPayment from "../methods/CardPayment";

export default function CardStep({
  amount,
  onBack,
}: {
  amount: number;
  onBack: () => void;
}) {
  return (
    <CardPayment
      amount={amount}
      currency="RF"
      onBack={onBack}
      onSubmit={(data) => {
        console.log("Card payment:", data);
      }}
    />
  );
}